/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '@dm/core';

import { SmartAssistantSwitchModule } from '../smart-assistant-switch/smart-assistant-switch.module';
import { SmartAssistantAlarmsComponent } from './assistant-alarms.component';
import { SmartAssistantAlarmsStrService } from './assistant-alarms-str.service';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        SmartAssistantSwitchModule,
    ],
    declarations: [SmartAssistantAlarmsComponent],
    exports: [SmartAssistantAlarmsComponent],
    providers: [SmartAssistantAlarmsStrService],
})
export class SmartAssistantAlarmsModule { }
